<div class="err text-danger small">

    @if(control && control.touched && control.errors){
    @if(control.errors.required){
    <div>*Required</div>
    }
    @if(control.errors.maxlength){
    <div> *Maximum length {{control.errors.maxlength.requiredLength}} characters </div>
    }
    @if(control.errors.minlength){
    <div> *Minimum length {{control.errors.minlength.requiredLength}} characters </div>
    }
    @if(control.errors.min){
    <div> *Min {{control.errors.min.min}} </div>
    }
    @if(control.errors.max){
    <div> *Max {{control.errors.max.max}} </div>
    }
    @if(control.errors.email || control.errors.pattern?.requiredPattern == emailRegex){
    <div> *Invalid email format </div>
    }
    @if(control.errors.password || control.errors.pattern?.requiredPattern == passwordRegex){
    <div> *Password must be 8 to 32 characters long and include at least one uppercase letter, one lowercase letter, and
        one number, using only letters and numbers </div>
    }
    @if(control.errors.targetUrl || control.errors.pattern?.requiredPattern == urlRegex){
    <div> *Invalid Url </div>
    }
    @if(control.errors.endDateInvalid){
    <div> *End date must be after the start date </div>
    }

    }
</div>